import Vue from 'vue'

// 自动导入当前目录下所有以大写字母开头的 .vue 文件（你也可以调整正则表达式）
const requireComponent = require.context(
  // 组件目录相对于此文件
  './globalcomponents',
  // 是否递归查找子目录
  false,
  // 匹配基础组件文件名的正则表达式
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName)
  // 获取组件的 PascalCase 命名，用于注册全局组件
  const componentName = fileName
    .replace(/^\.\/(.*)\.\w+$/, '$1')
  // 全局注册组件
  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})